import React from 'react';
import { FaHandsHelping } from 'react-icons/fa';
import {
  SectionContentWrapper,
  WhiteCard,
  GlassContainer,
  ContentText,
  TwoColumnSection,
  MapImage,
} from './CommunityImpact.styles';

const CommunityImpact: React.FC = () => {
  return (
    <GlassContainer>
      <WhiteCard>
        <SectionContentWrapper>
          <h2>
            <FaHandsHelping style={{ marginRight: '0.5rem', color: '#673AB7' }} />
            Community Impact
          </h2>
          <ContentText>
            <p>
              We begin our journey in Ethiopia, but our ripple effect is poised to expand to many low- and middle-income countries.
              Our work extends far beyond the individuals we serve. By fostering a culture of care, compassion, and understanding,
              we aim to create a ripple effect that benefits families, communities, and healthcare systems as a whole.
            </p>
          </ContentText>
          <TwoColumnSection>
            <MapImage src="images/ethiopia-map.png" alt="Map of Ethiopia" />
            <div>
              <p>
                We believe in the power of community involvement. Our volunteer programs provide individuals with the opportunity to
                make a meaningful difference in the lives of those facing terminal illnesses. Volunteers offer companionship,
                support, and assistance, creating a network of care that strengthens community bonds.
              </p>
            </div>
          </TwoColumnSection>
          <ContentText>
            <p>
              The impact of our work is best illustrated through the stories of those we serve. Each narrative reflects the profound
              difference that compassionate care can make in the lives of patients and their families.
            </p>
          </ContentText>
        </SectionContentWrapper>
      </WhiteCard>
    </GlassContainer>
  );
};

export default CommunityImpact;
